import { render, staticRenderFns } from "./groupMessages.vue?vue&type=template&id=3a0a2da7&scoped=true&"
import script from "./groupMessages.vue?vue&type=script&lang=ts&"
export * from "./groupMessages.vue?vue&type=script&lang=ts&"
import style0 from "./groupMessages.vue?vue&type=style&index=0&id=3a0a2da7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0a2da7",
  null
  
)

export default component.exports